module.exports = "//static.hsappstatic.net/signup-ui-lego/static-1.20284/images/google-workspace-app-authorization-connect.svg"